import { shallowEqual, useSelector } from 'react-redux'


const selector = state=>state.submissions

export const useClassSubmissions = () =>{
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}